import "./navBar.css";
import { useState } from "react";
import Scrollspy from "react-scrollspy";
import navData from "../../Object Files/nav";

const LOGO_SRC = "/assets/professional_cv_photo.png";

const NavBar = ({ onClick, children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleIsOpen = () => {
    if (isOpen) setIsOpen(false);
  };

  return (
    <nav className="nav-cont" aria-label="Main">
      <a href="/#home" className="logo">
        <img
          src={LOGO_SRC}
          alt="Uche Ogbonna"
          className="circle-card-cont logo_img"
          loading="eager"
          decoding="async"
          fetchPriority="high"
          width={48}
          height={48}
        />
        <span className="logo_text">Uche Ogbonna</span>
      </a>
      <button
        type="button"
        className="switch"
        title="Toggle theme"
        onClick={onClick}
        aria-label="Toggle light and dark theme"
      >
        {children}
      </button>
      <Scrollspy
        items={["home", "about", "expertise", "project", "skill", "contact"]}
        currentClassName="active"
        className={`links-container ${isOpen ? "show-tab" : ""}`}
        onClick={handleIsOpen}
      >
        {navData.map((items) => (
          <li key={items.id}>
            <a
              href={items.link}
              className="flex links"
              onClick={handleIsOpen}
            >
              <i className={items.icon} aria-hidden="true"></i>
              {items.description}
            </a>
          </li>
        ))}
      </Scrollspy>

      <button
        type="button"
        className={`tab-icon ${isOpen ? "dark-tab-icon" : ""}`}
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
        aria-label={isOpen ? "Close menu" : "Open menu"}
      >
        {isOpen ? (
          <i className="fa-solid fa-x x" aria-hidden="true"></i>
        ) : (
          <i className="fa-solid fa-bars" aria-hidden="true"></i>
        )}
      </button>
    </nav>
  );
};

export default NavBar;
